export default "__VITE_ASSET__C54$iOBu__"